
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import type { ColumnsType } from "antd/es/table";
import { Table, ConfigProvider, Avatar, Tag } from "antd";
import {
    Menu, Tag as TagIcon, Mail, MessageCircleMore, FolderOutput, FolderInput, Settings,
    SlidersHorizontal, PanelLeft, PlayIcon, CheckIcon
} from 'lucide-react';


import Layout from '../../Layout';
import { useState } from "react";
import { mixformatCurrency } from "services/mixin";

interface RevenueItem {
    author: string;
    code: string;
    content: string;
    reason: string;
    ammount: number;
    bank: string;
    customer: string;
    status: string;
    approvalStep: number;
    date: string;
}

const tabs = [
    { id: 1, label: 'Tất cả', count: 334 },
    { id: 2, label: 'Chờ bạn duyệt', count: 0 },
    { id: 3, label: 'Phiếu bạn tạo', count: 2 },
    { id: 4, label: 'Phòng ban bạn', count: 2 },
    { id: 5, label: 'Đã duyệt', count: 185 },
    { id: 6, label: 'Chờ duyệt', count: 149 },

]

const revenueData: RevenueItem[] = [
    {
        author: "H",
        code: "PT__2026_617",
        content: "Thu tiền làm đep",
        reason: "Thu bán hàng",
        ammount: 250000000,
        bank: "(hienhtt) Ngân hàng MB Bank",
        customer: "Trung Phong",
        status: "Chờ duyệt",
        approvalStep: 1,
        date: "25/08/2026",
    },
    {
        author: "A",
        code: "PT__2026_616",
        content: "tê",
        reason: "Doanh thu",
        ammount: 4444444,
        bank: "(M) NGÂN HÀNG MBBANK",
        customer: "--",
        status: "Chờ duyệt",
        approvalStep: 1,
        date: "24/08/2026",
    },
    {
        author: "D",
        code: "PT__2026_615",
        content: "tt",
        reason: "Thu khác",
        ammount: 222222,
        bank: "(hienhtt) Ngân hàng MB Bank",
        customer: "--",
        status: "Đã duyệt",
        approvalStep: 2,
        date: "24/08/2026",
    },
    {
        author: "M",
        code: "PT__2026_614",
        content: "Thu tiền lần 1 lần 1 khách hàng Phạm Thanh Bình",
        reason: "Thu bán hàng",
        ammount: 550000,
        bank: "(M) NGÂN HÀNG MBBANK",
        customer: "--",
        status: "Đã duyệt",
        approvalStep: 2,
        date: "24/08/2026",
    },
]

export default function Revenue() {
    const [tab, setTab] = useState(1)
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const columns: ColumnsType<RevenueItem> = [
        {
            title: "Người tạo",
            dataIndex: "author",
            key: "author",
            render: (text) => (
                <Avatar className="bg-[#0087BF] text-[15px]">{text}</Avatar>
            ),
        },
        {
            title: "Mã phiếu thu",
            dataIndex: "code",
            key: "code",
            render: (text) => (
                <Link to={`#`}>
                    {text}
                </Link>
            ),
        },
        {
            title: "Nội dung thu",
            dataIndex: "content",
            key: "content",
        },
        {
            title: "Lý do thu",
            dataIndex: "reason",
            key: "reason",
        },
        {
            title: "Số tiền",
            dataIndex: "ammount",
            key: "ammount",
            align: "right",
            render: (value: number) => (
                <span>
                    {mixformatCurrency(value, true)}
                </span>
            ),
        },
        {
            title: "Tài khoản",
            dataIndex: "bank",
            key: "bank",
        },
        {
            title: "Khách hàng",
            dataIndex: "customer",
            key: "customer",
            render: (text) => text || "--",
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            align: "center",
            render: (status: string) => 
                <div className={`px-2 py-1 rounded text-[11px] font-medium inline-flex items-center gap-1 whitespace-nowrap ${status === "Chờ duyệt"
                    ? 'bg-orange-100 text-orange-500 dark:bg-orange-900/30 dark:text-orange-400'
                    : 'bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400'
                    }`}>
                    {status}
                </div>
        },
        {
            title: "Bước duyệt",
            dataIndex: "approvalStep",
            key: "approvalStep",
            align: "center",
            render: (step: number) =>
                <div className={`px-2 py-1 border rounded text-[11px] font-medium inline-flex items-center gap-1 whitespace-nowrap ${step === 1
                    ? 'border-orange-300 text-orange-500 bg-orange-50 dark:bg-orange-900/10'
                    : 'border-green-300 text-green-500 bg-green-50 dark:bg-green-900/10'
                    }`}>
                    Bước duyệt {step === 1 ? <PlayIcon size={12} /> : <CheckIcon size={12} />}
                </div>

        },
        {
            title: "Ngày thu",
            dataIndex: "date",
            key: "date",
            align: "center",
        },
    ];

    const rowSelection = {
        selectedRowKeys,
        onChange: (keys: React.Key[]) => setSelectedRowKeys(keys),
    };
    return (
        <Layout>
            <Helmet>
                <title> Phiếu thu | Khothi</title>
            </Helmet>
            <div className={`min-h-screen pb-10 transition-colors duration-300`}>
                {/* --- HEADER ACTIONS --- */}
                <div className="text-sm border-b dark:border-gray-700 px-4 md:px-6 py-3 pb-0 flex flex-wrap justify-between items-center gap-4 sticky top-[64px] bg-white dark:bg-[#1f1f1f] z-10 shadow-sm">

                    <div className='overflow-x-auto no-scrollbar'>
                        <div className="flex items-center gap-4 xl:gap-5 w-full xl:w-auto ml-auto min-w-max text-000000e0">
                            <Menu size={14} />
                            {tabs.map((item) => (
                                <button
                                    type="button"
                                    onClick={() => setTab(item.id)}
                                    className={`font-medium pb-1 border-b-2 transition-colors ${item.id === tab
                                        ? "text-[#3e91ab] border-[#3e91ab]"
                                        : "text-gray-500 dark:text-gray-400 border-transparent"
                                        }`}
                                >
                                    {item.label} ({item.count})
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Toolbar giống AssetListAntd */}
                <div className="text-slate-500 dark:text-slate-400 border-b dark:border-gray-700 px-4 md:px-6 py-3 flex flex-wrap justify-between items-center gap-4 sticky top-[64px] bg-white dark:bg-[#1f1f1f] z-10 shadow-sm">

                    <div className="flex sm:items-center gap-4 text-sm sm:flex-row flex-col items-start">
                        <div className="flex sm:items-center gap-4 text-sm items-start">
                            <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"> <SlidersHorizontal size={18} className="mr-1.5 text-gray-400" /></button>
                            <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"> <PanelLeft size={18} className="mr-1.5 text-gray-400" /></button>
                            {selectedRowKeys.length > 0 ? (
                                <span>
                                    Đã chọn <b>{selectedRowKeys.length}</b> bản ghi
                                </span>
                            ) : (
                                // <span>
                                //     Hiển thị 1 - 2 / 2 bản ghi
                                // </span>
                                <span> </span>
                            )}
                        </div>
                    </div>

                    <div className='overflow-x-auto no-scrollbar'>
                        <div className="flex items-center gap-4 xl:gap-5 w-full xl:w-auto ml-auto min-w-max">
                            <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"> <TagIcon size={14} className="mr-1.5 text-gray-400" /> Nhãn</button>
                            <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"> <Mail size={14} className="mr-1.5 text-gray-400" /> Email</button>
                            <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"> <MessageCircleMore size={14} className="mr-1.5 text-gray-400" /> Sms/Zalo</button>
                            <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"> <FolderOutput size={14} className="mr-1.5 text-gray-400" /> Export</button>
                            <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"> <FolderInput size={14} className="mr-1.5 text-gray-400" /> Import</button>
                            <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"> <Settings size={14} className="mr-1.5 text-gray-400" /> Cài đặt</button>

                        </div>
                    </div>
                </div>

                {/* Ant Design Table */}
                <div className="py-4">
                    <ConfigProvider
                        theme={{
                            components: {
                                Table: {
                                    headerBg: "#f8f9fa",
                                    headerColor: "#6b7280",
                                    cellPaddingBlock: 12,
                                    rowHoverBg: "#eff6ff",
                                },
                            },
                        }}
                    >
                        <Table
                            rowKey='code'
                            rowSelection={rowSelection}
                            columns={columns}
                            dataSource={revenueData}
                            scroll={{ x: "max-content" }}
                            pagination={{
                                pageSize: 50,
                                showSizeChanger: false,
                                showQuickJumper: false,
                                // position: ["topLeft"],
                                showTotal: (total, range) => (
                                    <span>
                                        Hiển thị {range[0]} - {range[1]} / {total} bản ghi
                                    </span>
                                ),
                            }}
                        />
                    </ConfigProvider>
                </div>

            </div>
        </Layout>
    )
}